import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "./../../lib/appconst";

interface ReportWarrantyActivationState extends ListState<any> {
}
class ReportWarrantyActivationModule extends ListModule<ReportWarrantyActivationState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
    changeHistories: new Array<any>()
  };
  actions = {
    async getAll(
      context: ActionContext<ReportWarrantyActivationState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/Report/warranty-activations", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async export(
      context: ActionContext<ReportWarrantyActivationState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/report-warranty-activations${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
   
  };

  mutations = {
    setCurrentPage(state: ReportWarrantyActivationState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ReportWarrantyActivationState, pagesize: number) {
      state.pageSize = pagesize;
    },
    refreshListData(state: ReportWarrantyActivationState)
    {
        state.list = new Array<any>();
    },
  };
}
const warrantyActivationModule = new ReportWarrantyActivationModule();
export default warrantyActivationModule;
